import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { logActivity } from '@/lib/activity';

/** Logs a page_view event whenever the signed-in user navigates. */
export const ActivityTracker = () => {
  const location = useLocation();
  const { user } = useAuth();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    if (!user) return;
    const path = location.pathname + location.search;
    if (lastPath.current === path) return;
    lastPath.current = path;
    logActivity('page_view', { path });
  }, [location.pathname, location.search, user]);

  return null;
};
